import { isAxiosError, isCancel } from "axios";
import type { QueryError } from "./types";

export const normalizeError = (error: unknown): QueryError => {
    if (isAxiosError(error)) {
        return {
            message: error.response?.data?.message ?? error.message ?? "Unknown error",
            statusCode: error.response?.status,
            cause: error,
            details: error.response?.data,
        };
    }

    if (error instanceof Error) {
        return {
            message: error.message,
            cause: error.cause,
        };
    }

    return {
        message: typeof error === "string" ? error : "Unknown error",
        details: error,
    };
};


/** Отменённый запрос — не ошибка: ключ сменился, ответ никому не нужен. */
export const isAbortError = (error: unknown): boolean => {
    if (isCancel(error)) return true;
    if (error && typeof error === "object") {
        const name = (error as { name?: unknown }).name;
        const code = (error as { code?: unknown }).code;
        return name === "AbortError" || name === "CanceledError" || code === "ERR_CANCELED";
    }
    return false;
};
